module.exports = __webpack_public_path__ + "img/792.00b93fd9.png";